const version = 'v0';
const prefix = `/api/${version}/accountswitch/control`;

export const Api = {
  Config: `api/frontendConfiguration`,
  ProductsAvailable: `api/${version}/products`,

  Sustainability: `api/${version}/sustainability`,
  SustainabilityCSV: `api/${version}/sustainability/csv`,

  Overview: `${prefix}/overview`,
  LogoUpload: `${prefix}/overview/logo`,
  DeprecatedBankCodes: `${prefix}/overview/deprecatedBankCodes`,

  KWH: `${prefix}/aid`,

  DeactivateKWHService: `${prefix}/aid/deactivateAidService`,
  ActivateKWHService: `${prefix}/aid/activateAidService`,
  ChangeKWHDeadline: `${prefix}/aid/changeKwhDeadline`,
  ChangeableBankDetails: `${prefix}/aid/changeableBankDetails`,
  LetterHead: `${prefix}/aid/letterHead`,
  LetterTemplatePreview: `${prefix}/aid/letterTemplatePreview`,
  LetterTemplate: `${prefix}/aid/letterTemplate`,
  ArchivingProtocol: `${prefix}/aid/archiving/changes`,
  Archiving: `${prefix}/aid/archiving`,
  ToggleAutoApplyStandingOrders: `${prefix}/aid/standingOrders`,
  ToggleStammdatenweitergabe: `${prefix}/aid/personendaten`,

  Users: `${prefix}/aid/manage/users`,
  UsersAsCsv: `${prefix}/aid/users`,
  CreateUser: `${prefix}/aid/manage/create`,
  DeleteUser: `${prefix}/aid/manage/delete`,
  SendPasswordMail: `${prefix}/aid/manage/sendPasswordMail`,

  KWS: `${prefix}/service`,
  KWSDns: `${prefix}/service/dns`,
  DisableWS: `${prefix}/disableKWS`,

  DWS: `/api/${version}/dws`,

  KwsCockpitLogin: `/api/${version}/cockpit/kws/login`,
  BestandskundenCockpitLogin: `/api/${version}/cockpit/bestandskunden/login`,

  Tenant: `/api/${version}/tenant`,
};
